import { render, staticRenderFns } from "./PrimaryPageContent.vue?vue&type=template&id=35b80310&scoped=true"
import script from "./PrimaryPageContent.vue?vue&type=script&lang=ts"
export * from "./PrimaryPageContent.vue?vue&type=script&lang=ts"
import style0 from "./PrimaryPageContent.vue?vue&type=style&index=0&id=35b80310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b80310",
  null
  
)

export default component.exports